"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProbingForm = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Button = require("../Button");
var _Form = require("../Form");
var _FormItem = require("../FormItem");
var _Navbar = require("../Navbar");
var _PopupOrder = require("./components/PopupOrder");
var _PopupSelector = require("./components/PopupSelector");
var _TextArea = require("./components/TextArea");
var _show = require("../Modal/show");
var _Loader = require("../Loader");
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var DEFAULT_MIN_DESC_LENGTH = 50;
var DEFAULT_MAX_DESC_LENGTH = 500;
var ProbingForm = function ProbingForm(props) {
  var _limit$maxDescLength, _limit$minDescLength, _props$showFormItem, _props$showFormItem2, _props$showFormItem3, _props$showFormItem4, _props$showFormItem5, _props$showFormItem6, _props$showFormItem7, _props$showFormItem8;
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('probing-form');
  var subtitle = props.subtitle,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    userTabTypes = props.userTabTypes,
    limit = props.limit,
    descriptionPlaceholder = props.descriptionPlaceholder,
    minLimitPrompt = props.minLimitPrompt,
    minLimitPromptWhenError = props.minLimitPromptWhenError,
    formItemTitle = props.formItemTitle,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    _props$showNavbar = props.showNavbar,
    showNavbar = _props$showNavbar === void 0 ? true : _props$showNavbar,
    _props$navbarProps = props.navbarProps,
    navbarProps = _props$navbarProps === void 0 ? {} : _props$navbarProps,
    FileUpload = props.fileUploadSlot,
    stillNotFoundButtonText = props.stillNotFoundButtonText,
    stillNotFoundValueText = props.stillNotFoundValueText,
    uploadFilePrompt = props.uploadFilePrompt,
    _props$skipValidateUs = props.skipValidateUserTypeAndEnquiryType,
    skipValidateUserTypeAndEnquiryType = _props$skipValidateUs === void 0 ? false : _props$skipValidateUs;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    initialValues = _useState2[0],
    setInitialValues = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    enquiryTypeList = _useState4[0],
    setEnquiryTypeList = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    problemTypeList = _useState6[0],
    setProblemTypeList = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    showUserType = _useState8[0],
    setShowUserType = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    showEnquiryType = _useState10[0],
    setShowEnquiryType = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    showProblemType = _useState12[0],
    setShowProblemType = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    showOrderSelector = _useState14[0],
    setShowOrderSelector = _useState14[1];
  var _useState15 = (0, _react.useState)({
      title: ''
    }),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    popup = _useState16[0],
    setPopup = _useState16[1];
  var _useState17 = (0, _react.useState)({}),
    _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
    formValues = _useState18[0],
    setFormValues = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
    showConfirm = _useState20[0],
    setShowConfirm = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
    showLoading = _useState22[0],
    setShowLoading = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
    buttonLoading = _useState24[0],
    setButtonLoading = _useState24[1];
  var _ref = props.componentTrackingData || {},
    formItemTracking = _ref.formItem,
    submitButtonTracking = _ref.submitButton,
    navbarBackButtonTracking = _ref.navbarBackButton,
    confirmModalButtonTracking = _ref.confirmModalButton,
    userTypeTracking = _ref.userType,
    enquiryTypeTracking = _ref.enquiryType,
    selectOrderButtonTracking = _ref.selectOrderButton;
  var formRef = (0, _react.useRef)(null);
  var userType = formValues.userType,
    enquiryType = formValues.enquiryType,
    problemType = formValues.problemType,
    order = formValues.order,
    description = formValues.description,
    files = formValues.files;
  var maxDescLength = (_limit$maxDescLength = limit === null || limit === void 0 ? void 0 : limit.maxDescLength) !== null && _limit$maxDescLength !== void 0 ? _limit$maxDescLength : DEFAULT_MAX_DESC_LENGTH;
  var minDescLength = (_limit$minDescLength = limit === null || limit === void 0 ? void 0 : limit.minDescLength) !== null && _limit$minDescLength !== void 0 ? _limit$minDescLength : DEFAULT_MIN_DESC_LENGTH;
  var showUserTypeFormItem = (_props$showFormItem = props.showFormItem) === null || _props$showFormItem === void 0 ? void 0 : _props$showFormItem.showUserAndEnquiryType;
  var showEnquiryTypeFormItem = ((_props$showFormItem2 = props.showFormItem) === null || _props$showFormItem2 === void 0 ? void 0 : _props$showFormItem2.showUserAndEnquiryType) && (userType === null || userType === void 0 ? void 0 : userType.value);
  var showProblemTypeFormItem = readOnly ? problemType === null || problemType === void 0 ? void 0 : problemType.value : problemTypeList && problemTypeList.length;
  var showOrderFormItem = readOnly ? ((_props$showFormItem3 = props.showFormItem) === null || _props$showFormItem3 === void 0 ? void 0 : _props$showFormItem3.showOrderSelector) && (order === null || order === void 0 ? void 0 : order.orderSn) : ((_props$showFormItem4 = props.showFormItem) === null || _props$showFormItem4 === void 0 ? void 0 : _props$showFormItem4.showOrderSelector) && (enquiryType === null || enquiryType === void 0 ? void 0 : enquiryType.isInboundOrder);
  var showFileFormItem = !readOnly || readOnly && (files === null || files === void 0 ? void 0 : files.length); // 展示 userType 且已选，或不展示 userType

  var isUserTypeLegal = ((_props$showFormItem5 = props.showFormItem) === null || _props$showFormItem5 === void 0 ? void 0 : _props$showFormItem5.showUserAndEnquiryType) && (userType === null || userType === void 0 ? void 0 : userType.value) || !((_props$showFormItem6 = props.showFormItem) !== null && _props$showFormItem6 !== void 0 && _props$showFormItem6.showUserAndEnquiryType); // 展示 enquiryType 且已选，或不展示 enquiryType

  var isEnquiryTypeLegal = ((_props$showFormItem7 = props.showFormItem) === null || _props$showFormItem7 === void 0 ? void 0 : _props$showFormItem7.showUserAndEnquiryType) && (enquiryType === null || enquiryType === void 0 ? void 0 : enquiryType.value) || !((_props$showFormItem8 = props.showFormItem) !== null && _props$showFormItem8 !== void 0 && _props$showFormItem8.showUserAndEnquiryType); // 展示 problemType 且已选，或不展示 problemType

  var isProblemTypeLegal = showProblemTypeFormItem && (problemType === null || problemType === void 0 ? void 0 : problemType.value) || !showProblemTypeFormItem; // 展示订单选择器且已选，或不展示订单选择器

  var isOrderLegal = showOrderFormItem && (order === null || order === void 0 ? void 0 : order.orderSn) || !showOrderFormItem; // 填写描述，且符合字数限制

  var isDescriptionLegal = description && (description === null || description === void 0 ? void 0 : description.length) >= minDescLength && (description === null || description === void 0 ? void 0 : description.length) <= maxDescLength; // 都合法时才能点击提交按钮

  var enableSubmitButton = isUserTypeLegal && isEnquiryTypeLegal && isProblemTypeLegal && isOrderLegal && isDescriptionLegal;
  var openFormTime = Date.now();
  var onFormChange = function onFormChange(changedValues, newFormValues) {
    var newValues = _objectSpread({}, newFormValues);
    if (isObjectOnlyHaveKey(changedValues, 'userType')) {
      var _formRef$current, _formRef$current$setF;
      newValues = _objectSpread(_objectSpread({}, newValues), {}, {
        enquiryType: null,
        problemType: null,
        order: null
      }); // @ts-ignore;

      (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : (_formRef$current$setF = _formRef$current.setFieldsValue) === null || _formRef$current$setF === void 0 ? void 0 : _formRef$current$setF.call(_formRef$current, newValues);
    }
    if (isObjectOnlyHaveKey(changedValues, 'enquiryType')) {
      var _formRef$current2, _formRef$current2$set;
      newValues = _objectSpread(_objectSpread({}, newValues), {}, {
        problemType: null,
        order: null
      }); // @ts-ignore;

      (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : (_formRef$current2$set = _formRef$current2.setFieldsValue) === null || _formRef$current2$set === void 0 ? void 0 : _formRef$current2$set.call(_formRef$current2, newValues);
    }
    setFormValues(newValues);
  };
  var isObjectOnlyHaveKey = function isObjectOnlyHaveKey(obj, keyName) {
    return Object.keys(obj).length === 1 && obj[keyName];
  };
  var showUserTypeSelector = function showUserTypeSelector() {
    if (readOnly) {
      return;
    }
    setPopup({
      title: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.userType
    });
    setShowUserType(true);
  };
  var showEnquiryTypeSelector = function showEnquiryTypeSelector() {
    if (readOnly) {
      return;
    }
    setPopup({
      title: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.enquiryType
    });
    setShowEnquiryType(true);
  };
  var showProblemTypeSelector = function showProblemTypeSelector() {
    if (readOnly) {
      return;
    }
    setPopup({
      title: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.problemType
    });
    setShowProblemType(true);
  };
  var showOrderSelectorHandler = function showOrderSelectorHandler() {
    if (readOnly || (order === null || order === void 0 ? void 0 : order.orderId) !== _constants.STILL_NOT_FOUND_ORDER_ID) {
      return;
    }
    setShowOrderSelector(true);
  };
  var getInitialValues = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var result, _ref3, _userType, _enquiryType, _order, autoFill, userTypeInList, _userTypeInList$child, enquiryTypeInList;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setShowLoading(true);
              if (!props.getInitialValues) {
                _context.next = 9;
                break;
              }
              _context.next = 4;
              return props.getInitialValues();
            case 4:
              result = _context.sent;
              _ref3 = result || {}, _userType = _ref3.userType, _enquiryType = _ref3.enquiryType, _order = _ref3.order;
              autoFill = {}; // 如果是只读，后端返回什么就填什么

              if (readOnly) {
                autoFill = result;
              } else {
                // 编辑模式下，需要判断填充的选项是否在列表中
                if (_userType) {
                  userTypeInList = options.find(function (i) {
                    return i.value === (_userType === null || _userType === void 0 ? void 0 : _userType.value);
                  }); // 只有当前 userType 在列表中，才自动填充

                  if (userTypeInList) {
                    autoFill.userType = userTypeInList;
                    enquiryTypeInList = (_userTypeInList$child = userTypeInList.child) === null || _userTypeInList$child === void 0 ? void 0 : _userTypeInList$child.find(function (i) {
                      return i.value === (_enquiryType === null || _enquiryType === void 0 ? void 0 : _enquiryType.value);
                    }); // 只有当前 enquiryType 在列表中，才自动填充

                    if (enquiryTypeInList) {
                      autoFill.enquiryType = enquiryTypeInList;
                      setEnquiryTypeList(userTypeInList.child || []);
                      if (enquiryTypeInList.isInboundOrder) {
                        autoFill.order = _order;
                      }
                    }
                  }
                } // flow1 跳过 user type, enquiry type 校验

                if (skipValidateUserTypeAndEnquiryType) {
                  autoFill.userType = autoFill.userType || _userType;
                  autoFill.enquiryType = autoFill.enquiryType || _enquiryType;
                }
              }
              setInitialValues(autoFill);
            case 9:
              setShowLoading(false);
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function getInitialValues() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _props$onSubmit;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setButtonLoading(true);
              _context2.prev = 1;
              _context2.next = 4;
              return (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 ? void 0 : _props$onSubmit.call(props, formValues);
            case 4:
              _context2.next = 8;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
            case 8:
              setButtonLoading(false);
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 6]]);
    }));
    return function onSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();
  var onBackButtonClick = function onBackButtonClick() {
    var _props$confirmModal, _props$confirmModal2, _props$confirmModal3;
    var modal = (0, _show.show)({
      type: 'modal',
      active: showConfirm,
      closeWhenClickOutside: false,
      className: "".concat(PREFIX, "-confirm"),
      children: (_props$confirmModal = props.confirmModal) === null || _props$confirmModal === void 0 ? void 0 : _props$confirmModal.content,
      footer: {
        layout: 'horizontal',
        buttons: [{
          text: ((_props$confirmModal2 = props.confirmModal) === null || _props$confirmModal2 === void 0 ? void 0 : _props$confirmModal2.cancelText) || '',
          type: 'text',
          trackingData: confirmModalButtonTracking,
          componentData: {
            buttonType: 'cancel'
          },
          onClick: function onClick() {
            setShowConfirm(false);
            modal.destroy();
          }
        }, {
          text: ((_props$confirmModal3 = props.confirmModal) === null || _props$confirmModal3 === void 0 ? void 0 : _props$confirmModal3.confirmText) || '',
          trackingData: confirmModalButtonTracking,
          componentData: {
            buttonType: 'confirm'
          },
          onClick: function onClick() {
            var _props$navbarProps2, _props$navbarProps2$o;
            setShowConfirm(false);
            modal.destroy();
            (_props$navbarProps2 = props.navbarProps) === null || _props$navbarProps2 === void 0 ? void 0 : (_props$navbarProps2$o = _props$navbarProps2.onBackButtonClick) === null || _props$navbarProps2$o === void 0 ? void 0 : _props$navbarProps2$o.call(_props$navbarProps2);
          }
        }]
      },
      onClose: function onClose() {
        return setShowConfirm(false);
      }
    });
  };
  var getEmptyFields = function getEmptyFields(type) {
    var validators = {
      userType: showUserTypeFormItem && !(userType !== null && userType !== void 0 && userType.value),
      enquiryType: showEnquiryTypeFormItem && !(enquiryType !== null && enquiryType !== void 0 && enquiryType.value),
      problemType: showProblemTypeFormItem && !(problemType !== null && problemType !== void 0 && problemType.value),
      order: showOrderFormItem && !(order !== null && order !== void 0 && order.orderSn),
      description: !(description !== null && description !== void 0 && description.length),
      files: showFileFormItem && !(files !== null && files !== void 0 && files.length)
    };
    return Object.entries(validators).reduce(function (acc, _ref5) {
      var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
        id = _ref6[0],
        isEmpty = _ref6[1];
      if (isEmpty) {
        acc.push(type === 'id' ? id : formItemTitle[id]);
      }
      return acc;
    }, []);
  };
  (0, _react.useEffect)(function () {
    var userTypeId = userType === null || userType === void 0 ? void 0 : userType.value;
    var target = options.find(function (i) {
      return i.value === userTypeId;
    });
    if (userTypeId && !readOnly) {
      setEnquiryTypeList((target === null || target === void 0 ? void 0 : target.child) || []);
      setProblemTypeList([]);
    }
  }, [userType === null || userType === void 0 ? void 0 : userType.value, options, readOnly]);
  (0, _react.useEffect)(function () {
    var enquiryTypeId = enquiryType === null || enquiryType === void 0 ? void 0 : enquiryType.value;
    var target = enquiryTypeList.find(function (i) {
      return i.value === enquiryTypeId;
    });
    if (enquiryTypeId && !readOnly) {
      setProblemTypeList((target === null || target === void 0 ? void 0 : target.child) || []);
    }
  }, [enquiryType === null || enquiryType === void 0 ? void 0 : enquiryType.value, enquiryTypeList, readOnly]);
  (0, _react.useEffect)(function () {
    getInitialValues();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: PREFIX
  }, showLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-loading")
  }, /*#__PURE__*/_react.default.createElement(_Loader.ListLoader, null)), showNavbar && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Navbar.Navbar, (0, _extends2.default)({}, navbarProps, {
    onBackButtonClick: onBackButtonClick,
    trackingData: navbarBackButtonTracking,
    componentData: {
      openFormTime: openFormTime,
      emptyFieldsId: getEmptyFields('id'),
      emptyFieldsTitle: getEmptyFields('name')
    }
  })), subtitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-description")
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_Form.Form, {
    ref: formRef,
    className: "".concat(PREFIX, "-form"),
    initialValues: initialValues,
    readOnly: readOnly,
    onValuesChange: onFormChange
  }, showUserTypeFormItem ? /*#__PURE__*/_react.default.createElement(_FormItem.FormItem, {
    required: true,
    showArrow: !readOnly,
    label: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.userType,
    name: "userType",
    onClick: showUserTypeSelector,
    trackingData: formItemTracking
  }, /*#__PURE__*/_react.default.createElement(_PopupSelector.PopupSelector, {
    popup: _objectSpread({
      active: showUserType,
      onClose: function onClose(e) {
        var _e$stopPropagation;
        e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
        setShowUserType(false);
      },
      container: props.popupContainer,
      className: "".concat(PREFIX, "-popup")
    }, popup),
    trackingData: userTypeTracking,
    options: options
  })) : null, showEnquiryTypeFormItem ? /*#__PURE__*/_react.default.createElement(_FormItem.FormItem, {
    required: true,
    showArrow: !readOnly,
    label: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.enquiryType,
    name: "enquiryType",
    onClick: showEnquiryTypeSelector,
    trackingData: formItemTracking
  }, /*#__PURE__*/_react.default.createElement(_PopupSelector.PopupSelector, {
    popup: _objectSpread({
      active: showEnquiryType,
      onClose: function onClose(e) {
        var _e$stopPropagation2;
        e === null || e === void 0 ? void 0 : (_e$stopPropagation2 = e.stopPropagation) === null || _e$stopPropagation2 === void 0 ? void 0 : _e$stopPropagation2.call(e);
        setShowEnquiryType(false);
      },
      container: props.popupContainer,
      className: "".concat(PREFIX, "-popup")
    }, popup),
    trackingData: enquiryTypeTracking,
    options: enquiryTypeList
  })) : null, showProblemTypeFormItem ? /*#__PURE__*/_react.default.createElement(_FormItem.FormItem, {
    required: true,
    showArrow: !readOnly,
    label: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.problemType,
    name: "problemType",
    onClick: showProblemTypeSelector,
    trackingData: formItemTracking
  }, /*#__PURE__*/_react.default.createElement(_PopupSelector.PopupSelector, {
    popup: _objectSpread({
      active: showProblemType,
      onClose: function onClose(e) {
        var _e$stopPropagation3;
        e === null || e === void 0 ? void 0 : (_e$stopPropagation3 = e.stopPropagation) === null || _e$stopPropagation3 === void 0 ? void 0 : _e$stopPropagation3.call(e);
        setShowProblemType(false);
      },
      container: props.popupContainer,
      className: "".concat(PREFIX, "-popup")
    }, popup),
    options: problemTypeList
  })) : null, showOrderFormItem ? /*#__PURE__*/_react.default.createElement(_FormItem.FormItem, {
    required: true,
    label: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.order,
    layout: (order === null || order === void 0 ? void 0 : order.orderId) === _constants.STILL_NOT_FOUND_ORDER_ID ? 'horizontal' : 'vertical',
    showArrow: !readOnly && (order === null || order === void 0 ? void 0 : order.orderId) === _constants.STILL_NOT_FOUND_ORDER_ID,
    name: "order",
    onClick: showOrderSelectorHandler,
    trackingData: formItemTracking
  }, /*#__PURE__*/_react.default.createElement(_PopupOrder.PopupOrder, {
    active: showOrderSelector,
    setActive: setShowOrderSelector,
    panelTitleText: props.orderSelectorTitle,
    popupContainer: props.popupContainer,
    onLoadMore: props.loadMoreOrder,
    userTypes: userTabTypes,
    stillNotFoundButtonText: stillNotFoundButtonText,
    stillNotFoundValueText: stillNotFoundValueText,
    componentTrackingData: {
      selectOrderButton: selectOrderButtonTracking
    }
  })) : null, /*#__PURE__*/_react.default.createElement(_FormItem.FormItem, {
    required: true,
    showWordLimit: !readOnly,
    label: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.description,
    layout: "vertical",
    name: "description",
    maxLimit: maxDescLength,
    trackingData: formItemTracking
  }, /*#__PURE__*/_react.default.createElement(_TextArea.TextArea, {
    placeholder: descriptionPlaceholder,
    minLimit: minDescLength,
    maxLimit: maxDescLength,
    minLimitPrompt: minLimitPrompt,
    minLimitPromptWhenError: minLimitPromptWhenError
  })), showFileFormItem ? /*#__PURE__*/_react.default.createElement(_FormItem.FormItem, {
    label: formItemTitle === null || formItemTitle === void 0 ? void 0 : formItemTitle.files,
    layout: "vertical",
    name: "files",
    fieldName: "fileList",
    prompt: uploadFilePrompt,
    trackingData: formItemTracking
  }, /*#__PURE__*/_react.default.createElement(FileUpload, {
    isEditing: !readOnly
  })) : null), !readOnly && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-footer")
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    type: "primary",
    text: props.submitButtonText || '',
    className: "".concat(PREFIX, "-submit"),
    disabled: !enableSubmitButton,
    onClick: onSubmit,
    loading: buttonLoading,
    trackingData: submitButtonTracking,
    componentData: {
      openFormTime: openFormTime,
      emptyFieldsId: getEmptyFields('id'),
      emptyFieldsTitle: getEmptyFields('name')
    }
  })));
};
exports.ProbingForm = ProbingForm;